import DocViewer, { PDFRenderer, PNGRenderer } from "@cyntler/react-doc-viewer";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import "./style.css";
import { useNavigate } from "react-router-dom";
// import AddAplicatoionInformation, {
//   AgreeTerms,
// } from "../../Services/ApplicationInformation/AddAplicationInformation";
// import DocViewer, { PDFRenderer, PNGRenderer } from "cyntler/react-doc-viewer";
import { useDispatch, useSelector } from "react-redux";
import PDF from "./IAGI.pdf";
import PDF2 from "./IAGI2.pdf";
import $ from "jquery";
import Swal from "sweetalert2";
import { useState } from "react";
// import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import {
  AddApplication,
  AgreeTerms,
} from "../../../Redux/Reducers/Shared/ApplicationInformation";

const GeneralInstructions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [canClick, setCanClick] = useState(true);

  const state = useSelector((state) => {
    return {
      ApplicationInformation: state.ApplicationInformation,
      jsonData: state.FetchDataJson,
    };
  });
  const [activeDocument, setActiveDocument] = useState(PDF);
  const [language, setLanguage] = useState("ar");
  const toggleDocument = () => {
    setActiveDocument((prev) => (prev === PDF ? PDF2 : PDF));
  };

  // Function to add a new application
  const addNewApplication = async () => {
    if (canClick) {
      // Ensure the function doesn't run if already processing
      setCanClick(false); // Prevent multiple clicks
      const addapp = await dispatch(AddApplication()); // Call to add application information
      console.log(addapp, "addapp");
      // Check if the application was successfully added
      if (addapp.payload) {
        setCanClick(true); // Reset click allowance
        // If no result is returned (empty response)
        if (addapp.payload?.length == 0) {
          Swal.fire({
            title: "لايوجد دورة فعالة", // Show a message from the server
            icon: "info", // Info icon
            confirmButtonText: "خروج", // Confirmation button text
            cancelButtonText: "الغاء", // Cancel button text
            showCancelButton: false, // No cancel button
            showCloseButton: true, // Allow closing the popup
          }).then((res) => {
            if (res.isConfirmed) {
              // If user confirms
              window.location.replace("/SRFund/mainpage"); // Redirect to the main page
            }
          });
        } else {
          // Save the application ID to localStorage
          localStorage.setItem("ApplicationInformationId", addapp.payload);
          // Automatically agree to terms with the "approved" status
          const agreed = await dispatch(
            AgreeTerms({
              aI_ApplicationInformationId: addapp.payload,
              status: "approved",
            })
          );
          console.log(agreed,"agreed");
          
          if (agreed.payload) {
            navigate("/SRFund/MainResearcherInformainContainer"); // Redirect to the Application Information page
          }
        }
      }
    }
  };
  //render after loading ends
  return (
    <div className={`AgreeTerms ${language === "ar" ? "rtl" : "ltr"}`}>
      {!state.ApplicationInformation?.loadingApplicationInformation ? (
        <div>
          <div className="DocViewerContainer">
            <DocViewer
              className="DocViewer"
              documents={[{ uri: activeDocument }]}
              pluginRenderers={[PDFRenderer, PNGRenderer]}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                },
              }}
            />
          </div>

          <div className="ContainerButtonApproved">
            <div className="SectionLeft">
              <button
                className="language-toggle-button"
                onClick={() => {
                  if (language === "ar") {
                    setLanguage("en");
                    setActiveDocument(PDF2);
                  } else {
                    setLanguage("ar");
                    setActiveDocument(PDF);
                  }
                }}
              >
                🌐 {language === "ar" ? "العربية" : "English"}
              </button>
            </div>

            <div className="SectionLeft">
              <ButtonAHSF
                text={language === "ar" ? "موافق" : "Approve"}
                show={true}
                type="submitter"
                title={language === "ar" ? "موافق" : "Approve"}
                onClick={() => {
                  addNewApplication();
                }}
              />
            </div>
            <div className="SectionLeft">
              <ButtonAHSF
                text={language === "ar" ? "غير موافق" : "Disapprove"}
                show={true}
                type="submitter"
                title={language === "ar" ? "غير موافق" : "Disapprove"}
                onClick={() => {
                  $(".close-btn").trigger("click");
                }}
              />
            </div>
          </div>
        </div>
      ) : null}
      <LoaderAHSF show={!canClick} />
    </div>
  );
};

export default GeneralInstructions;
